var _defs, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew330({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 5.94,
    y1: 1.5,
    x2: 5.94,
    y2: 14.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 10.06,
    y1: 1.5,
    x2: 10.06,
    y2: 14.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew330);
export default __webpack_public_path__ + "static/media/Symbolpack_New_330.c177a1efcfb9c560929a46b452994712.svg";
export { ForwardRef as ReactComponent };